import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import UpdateOrderProduct from "../Sales/SalesProduct/UpdateOrderProduct";
import { useGetSalesListQuery } from "../../features/api/saleslistApi";
import { useGetReturnlistQuery } from "../../features/api/returnlistApi";
import { useGetProductQuery } from "../../features/api/productApi";

const ReturnProductList = () => {
  // const { data, error, isLoading } = useGetSalesListQuery(null, {
  //   refetchOnMountOrArgChange: true,
  // });
  // const orders = data?.orderss;

  const { data, error, isLoading } = useGetReturnlistQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const returnProducts = data?.returns;

  const { data: prod } = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const products = prod?.products;

  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }
  // const returnProducts = orders?.filter((data) => data?.return_qty > 0);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div>
      <div className="flex justify-between items-center px-12 my-4">
        <h1 className="text-xl font-bold">Return Product List</h1>
      </div>
      <div className="h-[75vh] overflow-auto max-w-sm lg:max-w-[960px] m-auto">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : returnProducts?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no Return list
          </p>
        ) : (
          <TableContainer component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <span className="font-bold">Sl No.</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Return No</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Product</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Quantity</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Sales Rate</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Total</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {returnProducts
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => {
                    const proName = products?.find(
                      (pro) => pro?.id === +row?.pro_name
                    );
                    return (
                      <TableRow key={row.id}>
                        <TableCell>{i + 1}</TableCell>
                        <TableCell>{row?.return_no}</TableCell>
                        <TableCell>{proName?.product_name}</TableCell>
                        <TableCell>{row?.qty}</TableCell>
                        <TableCell>{row?.sales_rate}</TableCell>
                        <TableCell>{row?.total}</TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[20, 30, 50]}
              component="div"
              count={returnProducts?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default ReturnProductList;